import { c as _c } from "react/compiler-runtime";
import { useSnapshot } from "valtio";
import { useConnectors } from "../../../../../polychain/hooks";
import { CUSTOM_PRIVY_CONNECTORS } from "../../../../../polychain/hooks/useConnectors";
import { FlowState } from "../../../../../stores/flowStore";
import { WALLET_OPTIONS } from "./constants";
export function useUninstalledWalletOptions() {
  const $ = _c(7);
  const {
    connectors
  } = useConnectors();
  const {
    flow
  } = useSnapshot(FlowState);
  const chainArch = flow?.type === "connect" ? flow.chainArch : undefined;
  let t0;
  if ($[0] !== chainArch || $[1] !== connectors) {
    let filteredWalletOptions = WALLET_OPTIONS;
    if (chainArch) {
      let t1;
      if ($[3] !== chainArch) {
        t1 = walletOption => walletOption.chainArchitectures.includes(chainArch);
        $[3] = chainArch;
        $[4] = t1;
      } else {
        t1 = $[4];
      }
      filteredWalletOptions = WALLET_OPTIONS.filter(t1);
    }
    let t1;
    if ($[5] !== connectors) {
      t1 = walletOption_0 => {
        const isPrivyConnector = CUSTOM_PRIVY_CONNECTORS.has(walletOption_0.id);
        if (isPrivyConnector) {
          return true;
        }
        return !connectors.some(c => {
          const isMatchingConnector = c.id === walletOption_0.id || c.chainArch === "EVM" && c.baseConnector.rdns?.includes(walletOption_0.id) || c.name === walletOption_0.name;
          return isMatchingConnector && c.isInstalled;
        });
      };
      $[5] = connectors;
      $[6] = t1;
    } else {
      t1 = $[6];
    }
    t0 = filteredWalletOptions.filter(t1);
    $[0] = chainArch;
    $[1] = connectors;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}